import { httpClient } from "../http/httpClient";

export interface GetAvailabilityResponse {
  available: boolean;
}

export async function getAvailability(cep: string) {
  const { data } = await httpClient
    .get<GetAvailabilityResponse>(`/crefaz/availability/${cep}`)
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
